/* Hero (homepage): „Răsfoiește plannerul” în ramă compactă.
   Comută între cele două replici, le scalează ca să încapă pe lățimea ramei
   (zoom pe .panel), deschide rama pe tot ecranul și o închide cu Escape.
   Replicile le desenează miresica-v2-planner-replica.js și
   miresica-v2-premium-replica.js; taburile foilor, miresica-v2-planner.js. */
(function () {
  'use strict';
  if (window.mcbHeroRasfoiesteInit) return;
  window.mcbHeroRasfoiesteInit = true;

  function toate(sel, radacina) {
    return Array.prototype.slice.call((radacina || document).querySelectorAll(sel));
  }

  function porneste(root) {
    var seg = root.querySelector('.hr-seg');
    var expand = root.querySelector('[data-hr-expand]');
    // Sub 750px rama nu derulează: butonul din ea deschide replica pe tot ecranul.
    var deschide = root.querySelector('[data-hr-deschide]');
    var eticheta = expand ? expand.querySelector('span') : null;
    var textMareste = root.getAttribute('data-text-mareste') || 'Mărește';
    var textInchide = root.getAttribute('data-text-inchide') || 'Închide';
    // Butonul „Vezi plannerul” din stânga: duce la pagina plannerului selectat în comutator.
    var hero = root.closest('.hero') || document;
    var linkPlanner = hero.querySelector('[data-hero-planner-link]');
    // Ghidul își are propriul text pe buton („Vezi ghidul”); plannerele păstrează textul din setări.
    var textLink = linkPlanner ? linkPlanner.textContent : '';

    // În rama compactă fiecare panou vizibil e scalat ca să încapă pe lățime.
    // Pe tot ecranul rămâne la mărime naturală (se derulează orizontal dacă e cazul).
    function potriveste() {
      var full = root.classList.contains('is-full');
      toate('.hr-pane:not([hidden]) .panel.on', root).forEach(function (p) {
        p.style.zoom = '1';
        if (full) return;
        var latime = p.parentNode.clientWidth - 4;
        var natural = p.scrollWidth;
        if (!natural || latime <= 0) return;
        // Plafon 0,75 în rama compactă: foaia se vede „de la distanță”, cu mai mult conținut în cei 440px;
        // detaliile se citesc pe tot ecranul (Mărește), unde zoom-ul e 1.
        var z = Math.max(0.55, Math.min(0.75, latime / natural));
        p.style.zoom = z.toFixed(3);
      });
    }

    function comuta(care) {
      toate('[data-hr-planner]', seg).forEach(function (b) {
        var on = b.getAttribute('data-hr-planner') === care;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && linkPlanner && b.getAttribute('data-hr-url')) linkPlanner.setAttribute('href', b.getAttribute('data-hr-url'));
        if (on && linkPlanner) linkPlanner.textContent = b.getAttribute('data-hr-buton') || textLink;
      });
      toate('[data-hr-pane]', root).forEach(function (p) {
        p.hidden = p.getAttribute('data-hr-pane') !== care;
      });
      // Replica Premium stă nedesenată până la prima comutare (data-mcb-replica="v2-lazy").
      var lazy = root.querySelector('[data-hr-pane="' + care + '"] [data-mcb-replica="v2-lazy"]');
      if (lazy && typeof window.mcbReplicaPremium === 'function') {
        lazy.setAttribute('data-mcb-replica', 'v2');
        window.mcbReplicaPremium(lazy);
      }
      if (deschide) deschide.textContent = deschide.getAttribute(care === 'ghid' ? 'data-text-ghid' : 'data-text-planner');
      var scroll = root.querySelector('.hr-scroll');
      if (scroll) scroll.scrollTop = 0;
      potriveste();
    }

    function seteaza(full) {
      root.classList.toggle('is-full', full);
      document.body.classList.toggle('hero-rasfoieste-deschis', full);
      if (expand) expand.setAttribute('aria-expanded', full ? 'true' : 'false');
      if (eticheta) eticheta.textContent = full ? textInchide : textMareste;
      potriveste();
      var tinta = !full && deschide && deschide.offsetParent ? deschide : expand;
      if (tinta) tinta.focus();
    }

    if (seg) {
      // Planner selectat din start (Premium): îi desenează replica și pune linkul „Vezi plannerul” pe pagina lui.
      var initial = seg.querySelector('[data-hr-planner].on');
      if (initial) comuta(initial.getAttribute('data-hr-planner'));
      seg.addEventListener('click', function (e) {
        var b = e.target.closest('[data-hr-planner]');
        if (!b || !seg.contains(b)) return;
        comuta(b.getAttribute('data-hr-planner'));
      });
    }
    if (expand) {
      expand.addEventListener('click', function () {
        seteaza(!root.classList.contains('is-full'));
      });
    }
    if (deschide) {
      deschide.addEventListener('click', function () {
        seteaza(true);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-full')) seteaza(false);
    });
    // După ce miresica-v2-planner.js schimbă foaia, panoul nou primește și el zoom-ul.
    toate('[data-tabs]', root).forEach(function (bara) {
      bara.addEventListener('click', function () {
        window.setTimeout(potriveste, 0);
      });
    });
    window.addEventListener('resize', potriveste);
    window.addEventListener('load', potriveste);
    // Replicile se desenează tot la DOMContentLoaded, din scripturile încărcate înainte;
    // un tic mai târziu panourile au lățimea reală.
    window.setTimeout(potriveste, 0);
    window.setTimeout(potriveste, 600);
  }

  function toateRamele() {
    toate('[data-hero-rasfoieste]').forEach(porneste);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', toateRamele);
  } else {
    toateRamele();
  }
})();
